// extracted by mini-css-extract-plugin
export default {"mainContainer":"FilterTab_mainContainer__9SMaO","lefticon":"FilterTab_lefticon__qTa19","righticon":"FilterTab_righticon__gFzJX","label":"FilterTab_label__MehT4"};